import { OwaDate, now } from 'owa-datetime';
import type { Todo } from 'owa-todo-types';
import { createTodos } from 'owa-todo-actions';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import { setTaskId, showRetryNotification } from 'owa-timestream-store';
import { SPACES_ACTION_SOURCE } from '../constants';
import createTaskFolder from './createTaskFolder';
import loc from 'owa-localize';
import { failedToCreateTask, failedToCreateTaskFolder } from './createTaskErrors.locstring.json';

export default async function createTask(
    projectId: ProjectId,
    assetId: AssetId,
    tasksParentFolderId: string,
    taskTitle: string,
    dueDate?: OwaDate,
    onTaskCreated?: (todo: Todo) => void
) {
    setTaskId(projectId, assetId, 'CREATING', dueDate, true /* onlySetLocally */);

    let taskFolderId: string = tasksParentFolderId;
    if (!taskFolderId) {
        const createdTaskFolderId = await createTaskFolder(projectId);
        if (createdTaskFolderId) {
            taskFolderId = createdTaskFolderId;
        } else {
            showRetryNotification('createTaskFolder', loc(failedToCreateTaskFolder), retry => {
                if (retry) {
                    createTask(
                        projectId,
                        assetId,
                        tasksParentFolderId,
                        taskTitle,
                        dueDate,
                        onTaskCreated
                    );
                }
            });
        }
    }

    if (taskFolderId) {
        createTodos(
            [{ Subject: taskTitle, DueDateTime: dueDate, OrderDateTime: now() }],
            taskFolderId,
            {
                actionSource: SPACES_ACTION_SOURCE,
                viewType: 'QuickAdd',
            }
        ).then(result => {
            if (result.success) {
                const createdTodo = result.items[0];
                !!onTaskCreated
                    ? onTaskCreated(createdTodo)
                    : setTaskId(
                          projectId,
                          assetId,
                          createdTodo.Id,
                          createdTodo.DueDateTime ?? undefined
                      );
            } else {
                showRetryNotification('createTask', loc(failedToCreateTask), retry => {
                    if (retry) {
                        createTask(
                            projectId,
                            assetId,
                            taskFolderId,
                            taskTitle,
                            dueDate,
                            onTaskCreated
                        );
                    }
                });
            }
        });
    }
}
